import React from "react";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import {
  getMediumNameForProjects,
  getShortNameForProjects,
} from "../../utensils/simplifier";
import { isMobile } from "react-device-detect";

const COLORS = ["#8884d8", "#82ca9d", "#ffc658", "#ff8042", "#d0ed57"];

const customLabel = ({ name, value }) => {
  return `${getShortNameForProjects(name)}: ${value} hrs`;
};

export const ProjectPieChart = ({ data }) => {
  return (
    <div className="w-full flex flex-col max-sm:bg-white max-sm:shadow items-center">
      <h1 className="text-center text-3xl font-semibold mb-4">
        Project Distribution
      </h1>
      <ResponsiveContainer
        width="100%"
        height={500}
        className="rounded max-sm:bg-white max-sm:shadow"
      >
        <PieChart>
          <Pie
            outerRadius={isMobile ? 180 : 200}
            innerRadius={isMobile ? 90 : 100}
            data={data}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="50%"
            paddingAngle={5}
            fill="#82ca9d"
            label={isMobile ? false : customLabel} // Hide labels on mobile
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip
            formatter={(value, name, entry) => [
              `${value} hours`,
              getMediumNameForProjects(name),
            ]}
          />
          <Legend
            verticalAlign="bottom"
            iconType="circle"
            wrapperStyle={{ fontSize: isMobile ? "10px" : "12px" }} // Smaller legend on mobile
            formatter={(value) => (
              <span style={{ color: "#333" }}>
                {getShortNameForProjects(value)}
              </span>
            )}
          />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};
